import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {GetServiceOrderApiResponse} from '@dms/api/workshop';

import {Nullish} from 'shared/web';

type PartsMovementsSection = NonNullable<NonNullable<GetServiceOrderApiResponse>['partsMovements']>;

export const getPartsMovementsTabIcon = (partsMovements?: PartsMovementsSection | Nullish) => {
  const conditions = [
    partsMovements?.serviceOrderIssueCompleted,
    partsMovements?.serviceOrderReturnsCompleted,
    partsMovements?.fastTrackIssuesCompleted,
  ];

  const hasFalse = conditions.includes(false);
  const allNullish = conditions.every((c) => isNil(c));

  return match({hasFalse, allNullish})
    .with({hasFalse: true}, () => 'pending' as const)
    .with({allNullish: true}, () => undefined)
    .otherwise(() => 'success' as const);
};
